import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=c650a43e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=c650a43e&prod&lang=less&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=c650a43e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c650a43e",
  null
  
)

export default component.exports